module.exports = __webpack_public_path__ + "static/media/nvshen-shipin.a651d9e7.png";